
<h1 mat-dialog-title>
    <div mat-dialog-content>
      <div class="float-left">
       {{headerTitle}}
      </div>
      <div class="float-right languageSelector">
        <span class="form-material">
              <select placeholder="Language" [(ngModel)]="currentLanguageCode" (change)="changeLanguage()">
                  <option *ngFor="let list of languages"  [ngValue]="list.Code">
            {{list.Name}}
                  </option>
              </select>
            </span>
      </div>
    </div>
  </h1>
